import { render } from "./OrderCardModal.vue?vue&type=template&id=551bdfce"
import script from "./OrderCardModal.vue?vue&type=script&lang=js"
export * from "./OrderCardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__